import {
  background,
  calc,
  useDisclosure,
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Input,
  Spacer,
  VStack,
  Select,
  Image,
  Text,
  Icon,
} from "@chakra-ui/react";
import { Card, Space, Spin, Table } from "antd";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Line, RiEditLine, RiSearch2Line } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { SET_MASTER_GIFTS } from "../../store/giftcards/giftcardsActionTypes";
import { useGiftsMaster } from "../../store/giftcards/reducer";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { REQUEST_MASTER_GIFTS } from "../../store/giftcards/giftcardsActionTypes";
import GiftsMasterEditDrawer from "../drawer/GiftsMasterEditDrawer";
import axios from "axios";
import GiftsDeleteConfirmation from "../modals/GiftsDeleteConfirmation";

interface Props {
  query: string;
}

const GiftsMasterTable: React.FC<Props> = ({ query }) => {
  const dispatch = useDispatch();
  const { masterGifts, busy } = useGiftsMaster();
  const searchColumns = useMemo(() => ["product_name"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [targetData, setTargetData] = useState<any>();
  const [selectedTab, setSelectedTab] = useState("template");
  const [purchasedCard, setPurchasedCard]: any = useState([]);
  const [redeemedCard, setRedeemedCard]: any = useState([]);

  // console.log(masterGifts, "mastergifts");

  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const deletes = (value: any) => {
    setTargetData(value);
    onDeleteOpen();
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const data = useMemo(
    () =>
      masterGifts.map((item: any) => ({
        key: item._id,
        themeImg: `${process.env.REACT_APP_IMAGE_BASE_URL}/${item.image.url}`,
        theme: item.name,
        themeImgId: item.image._id,
      })),
    [masterGifts]
  );

  // const purchaseddata = [
  //   {
  //     key: "1",
  //     transactionid: "356496",
  //     userName: "user 1",
  //     giftcardAmount: "£4",
  //     selectedTheme: "Any occassion",
  //     purchasedDate: "03 Jan 2025 - 12:30",
  //     paymentStatus: "Success",
  //   },
  // ];

  const purchaseddata = useMemo(
    () =>
      purchasedCard.map((item: any) => ({
        key: item._id,
        transactionid: item.paymentId || "-",
        userName: `${item?.createdBy?.firstName || "Not"} ${
          item?.createdBy?.lastName || "Available"
        }`,
        giftcardAmount: `£${item.amount}`,
        selectedTheme: item?.templateId?.name || "-",
        purchasedDate: item.createdAt,
        paymentStatus: item.status,
      })),
    [purchasedCard]
  );

  // const redeemeddata = [
  //   {
  //     key: "1",
  //     userName: "user 1",
  //     redeemCode: "65654561",
  //     redeemAmount: "£4",
  //     redeemDate: "03 Jan 2025 - 12:30",
  //     redeemStatus: "Success",
  //   },
  // ];

  const redeemeddata = useMemo(
    () =>
      redeemedCard.map((item: any) => ({
        key: item._id,
        userName: `${item?.redeemedBy?.firstName || "Not"} ${
          item?.redeemedBy?.lastName || "Available"
        }`,
        redeemCode: item.code,
        redeemAmount: `£${item.amount}`,
        redeemDate: item.createdAt,
        redeemStatus: item.status,
      })),
    [redeemedCard]
  );

  const filteredData = useMemo(() => {
    if (selectedTab === "template") {
      return data.filter((item: any) =>
        item.theme.toLowerCase().includes(searchText.toLowerCase())
      );
    } else if (selectedTab === "purchased") {
      return purchaseddata.filter((item: any) =>
        item.userName.toLowerCase().includes(searchText.toLowerCase())
      );
    } else if (selectedTab === "redeemed") {
      return redeemeddata.filter((item: any) =>
        item.userName.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    return [];
  }, [selectedTab, data, purchaseddata, redeemeddata, searchText]);

  const updateEvent = (eventMaster: any) => {
    setTargetData(eventMaster);
    onOpen();
  };

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Theme Image",
      dataIndex: "themeImg",
      width: 100,
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Theme",
      dataIndex: "theme",
      width: 130,
    },

    {
      title: "Action",
      key: "action",
      width: 100,
      render: (value: any) => (
        <Space size="middle">
          <RiEditLine
            onClick={() => {
              updateEvent(value);
            }}
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
          />
          <RiDeleteBin6Line
            onClick={() => {
              deletes(value);
            }}
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
          />
        </Space>
      ),
    },
  ];

  const purchasedColumns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionid",
      width: 100,
    },
    {
      title: "Username",
      dataIndex: "userName",
      width: 130,
    },

    {
      title: "Gift card amount",
      dataIndex: "giftcardAmount",
      width: 130,
    },

    {
      title: "Selected theme",
      dataIndex: "selectedTheme",
      width: 130,
    },

    {
      title: "Date of purchase",
      dataIndex: "purchasedDate",
      width: 130,
    },
    {
      title: "Payment status",
      dataIndex: "paymentStatus",
      width: 130,

      render: (paymentStatus: any) => {
        let bgColor = "rgba(2, 164, 50, 0.10)";
        let textColor = "#02A432";
        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            {paymentStatus}
          </span>
        );
      },
    },
  ];

  const redeemedColumns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Username",
      dataIndex: "userName",
      width: 130,
    },
    {
      title: "Redemption code",
      dataIndex: "redeemCode",
      width: 100,
    },

    {
      title: "Redemption amount",
      dataIndex: "redeemAmount",
      width: 130,
    },
    {
      title: "Redemption date",
      dataIndex: "redeemDate",
      width: 130,
    },
    {
      title: "Redemption status",
      dataIndex: "redeemStatus",
      width: 130,
      render: (redeemStatus: any) => {
        let bgColor = "rgba(2, 164, 50, 0.10)";
        let textColor = "#02A432";
        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "6px 10px",
              borderRadius: "6px",
              fontSize: "14px",
            }}
          >
            {redeemStatus}
          </span>
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // console.log(purchasedCard, ".......................");

  useEffect(() => {
    const fetchGiftCardData = async () => {
      try {
        if (selectedTab === "purchased") {
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/admin/gift-card?lifeline=active`
          );
          setPurchasedCard(response.data.data);
        } else if (selectedTab === "redeemed") {
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/admin/gift-card?lifeline=redeemed`
          );
          setRedeemedCard(response.data.data);
        }
      } catch (error) {
        // console.error("Error fetching gift card data:", error);
      }
    };

    fetchGiftCardData();
  }, [selectedTab]);

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                autoComplete="off"
                placeholder="Search or type a command"
                onChange={(e) => setSearchText(e.target.value)}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none", // Add this line to remove the blue outline
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none", // Add this line to ensure outline is removed in all browsers
                }}
              />
            </Box>
            <Spacer />

            {selectedTab === "template" && (
              <Box
                background="#E24441"
                fontSize={"sm"}
                color="#fff"
                w="fit-content"
                textAlign="center"
                p={3}
                onClick={() => {
                  onOpen();
                  setTargetData("");
                }}
                cursor="pointer"
                borderRadius="8px"
                _hover={{ background: "#E24441" }}
              >
                + Add gift card template
              </Box>
            )}
          </Flex>
          <Spacer></Spacer>
          <Flex gap="8px">
            <Box
              background={selectedTab === "template" ? "#E24441" : "#FFF"}
              fontSize={"sm"}
              color={selectedTab === "template" ? "#fff" : "#212121"}
              w="fit-content"
              textAlign="center"
              p={3}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441", color: "#fff" }}
              onClick={() => setSelectedTab("template")}
            >
              Gift card Template
            </Box>
            <Box
              background={selectedTab === "purchased" ? "#E24441" : "#FFF"}
              fontSize={"sm"}
              color={selectedTab === "purchased" ? "#fff" : "#212121"}
              w="fit-content"
              textAlign="center"
              p={3}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441", color: "#fff" }}
              onClick={() => setSelectedTab("purchased")}
            >
              Purchased gift cards
            </Box>
            <Box
              background={selectedTab === "redeemed" ? "#E24441" : "#FFF"}
              fontSize={"sm"}
              color={selectedTab === "redeemed" ? "#fff" : "#212121"}
              w="fit-content"
              textAlign="center"
              p={3}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441", color: "#fff" }}
              onClick={() => setSelectedTab("redeemed")}
            >
              Redeemed gift cards
            </Box>
          </Flex>
          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={
              selectedTab === "template"
                ? columns
                : selectedTab === "purchased"
                ? purchasedColumns
                : selectedTab === "redeemed"
                ? redeemedColumns
                : undefined
            }
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={busy && filteredData.length === 0 ? true : false}
          />
        </div>
      </div>

      {isOpen && (
        <GiftsMasterEditDrawer isOpen onClose={onClose} event={targetData} />
      )}

      {isDeleteOpen && targetData && (
        <GiftsDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetData}
        />
      )}
    </>
  );
};

export default GiftsMasterTable;
